import React, { FC, ReactElement, ReactNode, lazy } from 'react';

interface ErrorBoundaryProps {
  fallback: ReactElement;
  children: ReactNode;
}

const ErrorBoundaryLazy = lazy(async () =>
  import('@sentry/react').then(({ ErrorBoundary }) => ({
    default: ErrorBoundary,
  }))
);

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children, fallback }) => (
  <ErrorBoundaryLazy fallback={fallback}>{children}</ErrorBoundaryLazy>
);
